export default __webpack_public_path__ + "static/media/biggerrewards-valueprop.d6f19014.svg";